<template>
                <div class="news-items mt54">
                    
                    <a href="https://mp.weixin.qq.com/s/meioXmnyu1uZbrIByE4bIw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1719221998113379.png" alt="澳门质量品牌国际认证联盟与铜仁市政府签署战略合作框架协议" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">06/02<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">澳门质量品牌国际认证联盟与铜仁市政府签署战略合作框架协议</div>
                                <div class="desc">6月2日，澳门质量品牌国际认证联盟与铜仁市政府举行战略合作框架协议签约仪式。铜仁市市委常委、市政府副市长于毅主持签约仪式，并与澳门质量品牌国际认证联盟秘书长、融贯国际总经理陈祥代表双方签署协议。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/OBTHPVeJc3__i_BXSyYygA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1719221882886133.jpg" alt="2024第四届数字贸易创新应用峰会在澳门成功举办，中葡数字贸易人才基地正式启动" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">05/30<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">2024第四届数字贸易创新应用峰会在澳门成功举办，中葡数字贸易人才基地正式启动</div>
                                <div class="desc">5月30日， 2024第四届数字贸易创新应用峰会在澳门成功举办，本届峰会以“鲁澳携手迎双庆·数促新质生产力”为主题。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/rJ4JTRgvkdjIGWQdAY-5UQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1719221836936211.jpg" alt="澳门融贯与方圆标志认证签订战略合作协议，推进中葡质量认证工作" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">05/30<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">澳门融贯与方圆标志认证签订战略合作协议，推进中葡质量认证工作</div>
                                <div class="desc">为进一步服务与葡语国家在电子商务等领域的合作，澳门融贯与方圆标志认证集团达成战略合作关系，共同推进中葡质量认证工作发展。双方于5月30日举办的2024第四届数字贸易创新应用峰会仪式环节签署战略合作协议，澳门融贯董事长冯文滔，方圆标志认证集团广东有限公司常务副总经理熊飞彪代表签约。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/wZFaGeR6UqUy_DYsGUoduw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1719221782823711.jpg" alt="2024年港澳青年就业技能实践活动暨港澳青年就业创业百团万人湾区行顺利进行" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">05/24<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">2024年港澳青年就业技能实践活动暨港澳青年就业创业百团万人湾区行顺利进行</div>
                                <div class="desc">5月24日至26日，由珠海市人力资源和社会保障局主办，珠海市职业训练指导服务中心承办，澳门融贯投资科技有限公司、澳门369合伙小镇等单位协办，为期3日的“2024年港澳青年就业技能实践活动暨港澳青年就业创业百团万人湾区行”于珠海顺利举行。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/aScZOXz7myC5GKzZZnxbNw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1719221736213955.png" alt="川澳数字经济及大健康产业考察交流活动圆满完成" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">04/23<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">川澳数字经济及大健康产业考察交流活动圆满完成</div>
                                <div class="desc"></div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/A2JaktKIWB-ZiUPeakruLw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1713785285620888.jpg" alt="中葡数字贸易平台亮相中国信通院2024星火生态大会" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">04/22<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">中葡数字贸易平台亮相中国信通院2024星火生态大会</div>
                                <div class="desc">4月18-19日，由中国信息通信研究院主办的2024星火生态大会在厦门开幕。融贯国际作为星火生态深度合作伙伴受邀参加，总经理陈祥携东望洋中葡数字贸易平台亮相。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/7Zp4SCxIBzWbgT4QR83sHw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1713695443408992.jpg" alt="发展新质生产力！粤港澳三地“绿色办公场所评价”项目启动" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">03/07<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">发展新质生产力！粤港澳三地“绿色办公场所评价”项目启动</div>
                                <div class="desc">为加强碳计量技术体系建设，推动粤港澳大湾区绿色评价深度融合，实现大湾区双碳计量标准国际互认，加快发展新质生产力，3月7日上午，粤港澳三地合作的“绿色办公场所评价”项目，在广州正式启动并签约。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/RMbAWjM5TtQCwleImk1SxA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1706584563311542.jpg" alt="澳门融贯助力大熊猫国家公园保护" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">01/28<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">澳门融贯助力大熊猫国家公园保护</div>
                                <div class="desc">1月28日，大熊猫国家公园生态产品认证合作暨自然文创研讨会在新津区中国天府农业博览园举行。澳门融贯总经理、澳门质量品牌国际认证联盟秘书长陈祥先生受邀参与研讨并就“澳优码”助力大熊猫国家公园区域品牌双化(国际化+数字化)推进作主旨分享。</div>
                            </div>
                        </div>
                    </a>
                    
                   
                </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

  </style>